import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  root: function root(t) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      background: ", ";\n      height: ", ";\n      position: absolute;\n      transition: all 0.2s ease-out;\n    "])), t.tabColorFocus, t.tabBorderWidth);
  },
  primary: function primary(t) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      background: ", ";\n    "])), t.tabColorPrimary);
  },
  success: function success(t) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      background: ", ";\n    "])), t.tabColorSuccess);
  },
  warning: function warning(t) {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      background: ", ";\n    "])), t.tabColorWarning);
  },
  error: function error(t) {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      background: ", ";\n    "])), t.tabColorError);
  }
});